import React, { FC } from 'react';

import { Flex, HStack, Spinner, Td, Text, Tr } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { PageInfo, Pagination } from 'components/Navigation';

interface NestedPagerRowProps {
  total: number;
  pageInfo: PageInfo;
  // "tables in RAW", after the "1-20 of 613" the pager shows.
  label: string;
  isFetching: boolean;

  onChange(info: PageInfo): void;
}

/**
 * The pager under an open database's schemas or an open schema's tables.
 * Each list pages on its own.
 */
export const NestedPagerRow: FC<NestedPagerRowProps> = props => {
  const { total, pageInfo, label, isFetching, onChange } = props;
  return (
    <Tr bg={customTheme.colors.gray['50']}>
      <Td colSpan={100} py={1}>
        <Flex justify="flex-end" align="center">
          <HStack spacing={2}>
            {isFetching && <Spinner size="xs" color="primary" />}
            <Pagination
              totalCount={total}
              pageInfo={pageInfo}
              onChange={onChange}
            />
            <Text fontSize="sm" color="gray.400">
              {label}
            </Text>
          </HStack>
        </Flex>
      </Td>
    </Tr>
  );
};
